import Modal from 'bootstrap/js/src/modal';

class FetchForgottenPasswordFormService {
    /*@ngInject*/
    constructor($log, $rootScope, $http, $compile, $timeout, CommonService) {
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$compile = $compile;
        this.$timeout = $timeout;

        this.CommonService = CommonService;

        this.modalPasswordForgotten = undefined;
    }

    internalFetchForm() {
        this.$log.debug('sending request for forgotten password form');
        let url = this.CommonService.getBaseUrl() + '/login/pw/request';
        this.$http.get(url, null)
            .then((response) => {
                var myScope = this.$rootScope.$new();
                $('body').append(this.$compile(response.data)(myScope));
                this.$timeout(() => {
                    this.modalPasswordForgotten = $('#modal__password-forgotten');
                    if (this.modalPasswordForgotten.length) {
                        new Modal(this.modalPasswordForgotten[0], {
                            show: true,
                            focus: true
                        });
                        this.modalPasswordForgotten.modal('show');
                    } else {
                        this.$log.error('no forgotten password modal present');
                    }
                }, 0);
            }, (error) => {
                this.$log.error('request for forgotten password form: ' + error.status + ' ' + error.statusText);
            });
    }

    fetchForgottenPasswordForm() {
        if (!this.modalPasswordForgotten) {
            this.internalFetchForm();
        } else {
            this.modalPasswordForgotten.modal('show');
        }
    }
}

export default FetchForgottenPasswordFormService;
